module.exports = new __parcel__URL__("first_tab_content_en.53a1324b.webp").toString();